export default "__VITE_ASSET__CgWw_xAe__$_?w=600__"